// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.

import initDatatables from "./angle/modules/tables/datatable";

$(function () {
  initDatatables();
});
